import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";

export function ListEditor({ items, onChange, placeholder, addLabel = "Aggiungi", testId, validate }) {
  const [draft, setDraft] = useState("");
  const add = () => {
    const v = draft.trim();
    if (!v || items.includes(v)) return;
    if (validate && !validate(v)) return;
    onChange([...items, v]);
    setDraft("");
  };
  return (
    <div data-testid={testId}>
      <div className="flex flex-wrap gap-2 mb-3">
        {items.length === 0 && <span className="text-sm text-taupe">Nessun elemento.</span>}
        {items.map((it) => (
          <span key={it} className="inline-flex items-center gap-2 bg-hair/40 border border-hair px-3 py-1 text-sm" data-testid={`${testId}-item-${it}`}>
            {it}
            <button type="button" onClick={() => onChange(items.filter((x) => x !== it))} aria-label={`Rimuovi ${it}`} data-testid={`${testId}-remove-${it}`} className="text-red-700 hover:text-red-900">
              <Trash2 size={13} />
            </button>
          </span>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input value={draft} onChange={(e) => setDraft(e.target.value)} placeholder={placeholder} data-testid={`${testId}-input`}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }} />
        <button type="button" onClick={add} data-testid={`${testId}-add`} className="shrink-0 min-h-[44px] inline-flex items-center justify-center gap-1 text-xs tracking-[0.14em] uppercase border border-ink px-3 py-2 hover:bg-ink hover:text-bone transition-colors">
          <Plus size={13} /> {addLabel}
        </button>
      </div>
    </div>
  );
}
